import styled from 'styled-components'

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100% - 1rem);
  margin-bottom: 1rem;
  background: #fff;
  border-radius: 0.5rem;
  box-shadow:
    0 0.46875rem 2.1875rem rgba(4, 9, 20, 0.03),
    0 0.9375rem 1.40625rem rgba(4, 9, 20, 0.03),
    0 0.25rem 0.53125rem rgba(4, 9, 20, 0.05),
    0 0.125rem 0.1875rem rgba(4, 9, 20, 0.03);
`

export const CardHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px 0;
`

export const CardTitle = styled.div`
  font-size: 1rem;
  font-weight: 600;
  color: #273576;
`

export const CardSubtitle = styled.div`
  font-size: 0.8rem;
  color: #6c757d;
  margin-top: 2px;
`

export const CardBody = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: ${(props) => props.minHeight || 0}px;
  padding: 8px 12px 12px;
`

export const Destaque = styled.div`
  text-align: right;
  white-space: nowrap;

  strong {
    display: block;
    font-size: 1.4rem;
    line-height: 1.2;
    color: #273576;
  }
  span {
    font-size: 0.75rem;
    color: #6c757d;
  }
`

export const Kpi = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  height: calc(100% - 1rem);
  margin-bottom: 1rem;
  padding: 16px 18px;
  background: #fff;
  border-radius: 0.5rem;
  border-left: 4px solid ${(props) => props.cor};
  box-shadow:
    0 0.46875rem 2.1875rem rgba(4, 9, 20, 0.03),
    0 0.25rem 0.53125rem rgba(4, 9, 20, 0.05),
    0 0.125rem 0.1875rem rgba(4, 9, 20, 0.03);
`

export const KpiIcone = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  color: ${(props) => props.cor};
  background: ${(props) => props.cor}1a;
`

export const KpiTexto = styled.div`
  min-width: 0;

  span {
    display: block;
    font-size: 0.78rem;
    line-height: 1.2;
    color: #6c757d;
  }
  strong {
    display: block;
    font-size: 1.2rem;
    line-height: 1.25;
    color: #1f2937;
  }
  small {
    display: block;
    font-size: 0.72rem;
    color: #6c757d;
  }
`
